import { Dialog, DialogPanel, Description, DialogTitle } from '@headlessui/react';

const DialogBox = ({ isOpen, setIsOpen, title, message, approveCopy, declineCopy }) => {

  return (
    <Dialog open={isOpen} onClose={() => setIsOpen(false)} className="relative z-50">
      <div className="fixed inset-0 bg-black/20 backdrop-blur-sm" aria-hidden="true" />
        <div className="fixed inset-0 flex items-center justify-center p-4">
          <DialogPanel className="w-full max-w-md rounded-2xl bg-white shadow-xl px-6 py-8 space-y-6 border border-gray-200">
            <DialogTitle className="text-lg font-semibold text-gray-900">{title}</DialogTitle>
            <Description className="text-gray-600">{message}</Description>
            <div className="flex justify-end gap-3 pt-2">
              <button 
                onClick={() => setIsOpen(false)}
                className="px-4 py-2 text-sm rounded-md bg-indigo-600 text-white hover:bg-indigo-700"
              >
                {approveCopy || 'OK'}
              </button>
              {declineCopy &&(
                <button onClick={() => setIsOpen(false)}>{declineCopy}</button>
              )}
            </div>
          </DialogPanel>
        </div>
    </Dialog>
  )
}

export default DialogBox;